(ns app.front.view.admin.migration.create-default-agenda-templates
  (:require [app.front.view.admin.migration.template :as admin-migration-template]
            [core.front.event :refer [>evt]]))

(defn view [match]
  [admin-migration-template/admin-page-for-migration
   {:task-id   :app.admin.migration.task/create-default-agenda-templates
    :title     "Create default agenda templates for domain groups"
    :help-text (str "This migration creates a 'Default template' meeting agenda template for each domain group "
                    "that has child groups with committee and doesn't already have a default template. "
                    "Requires the domain-level-meetings feature flag to be enabled.")}
   match])

(def route
  {:name        :view/admin.migration.create-default-agenda-templates
   :view        view
   :controllers [{:start (fn [_]
                           (>evt [::admin-migration-template/fetch-migration-tasks
                                  :app.admin.migration.task/create-default-agenda-templates]))}]})
